export enum ServiceName {
  ProfileManagement = 'ProfileManagement',
  AccountManagement = 'AccountManagement',
  CentralAuth = 'CentralAuth',
}
